import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const routingTypeOptions = ['Practical', 'Shortest', 'Fastest'] as const;

export const routingTypeSchema = createEnumSchemaPreprocessor(
  z.enum(routingTypeOptions),
  routingTypeOptions
);

export type RoutingType = z.infer<typeof routingTypeSchema>;
